import { render, staticRenderFns } from "./task-card.vue?vue&type=template&id=51bd014c&"
import script from "./task-card.vue?vue&type=script&lang=js&"
export * from "./task-card.vue?vue&type=script&lang=js&"
import style0 from "./task-card.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports